import {
  ATTACHMENT_DELETE_DOCUMENT_FAIL,
  ATTACHMENT_DELETE_DOCUMENT_REQUEST,
  ATTACHMENT_DELETE_DOCUMENT_SUCCESS,
  ATTACHMENT_GENERATE_SAS_URLS_FAIL,
  ATTACHMENT_GENERATE_SAS_URLS_REQUEST,
  ATTACHMENT_GENERATE_SAS_URLS_SUCCESS,
  ATTACHMENT_GET_BY_ID_FAIL,
  ATTACHMENT_GET_BY_ID_REQUEST,
  ATTACHMENT_GET_BY_ID_SUCCESS,
  ATTACHMENT_LIST_DOCUMENTS_FAIL,
  ATTACHMENT_LIST_DOCUMENTS_REQUEST,
  ATTACHMENT_LIST_DOCUMENTS_SUCCESS,
  ATTACHMENT_RESET,
  ATTACHMENT_UPLOAD_DOCUMENTS_FAIL,
  ATTACHMENT_UPLOAD_DOCUMENTS_REQUEST,
  ATTACHMENT_UPLOAD_DOCUMENTS_SUCCESS
} from '@/constants/RelatedDocumentConstants'

const initialState = {
  loading: false,
  error: null,
  attachment: null,
  documents: [],
  count: 0,
  uploadResults: null,
  sasUrls: null,
  deleteSuccess: false
}

export const relatedDocumentReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Attachment by ID
    case ATTACHMENT_GET_BY_ID_REQUEST:
      return { ...state, loading: true, error: null }
    case ATTACHMENT_GET_BY_ID_SUCCESS:
      return { ...state, loading: false, attachment: action.payload }
    case ATTACHMENT_GET_BY_ID_FAIL:
      return { ...state, loading: false, error: action.payload }

    // List Internal Documents
    case ATTACHMENT_LIST_DOCUMENTS_REQUEST:
      return { ...state, loading: true, error: null }
    case ATTACHMENT_LIST_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: action.payload.documents,
        count: action.payload.count
      }
    case ATTACHMENT_LIST_DOCUMENTS_FAIL:
      return { ...state, loading: false, error: action.payload }

    // Upload Internal Documents
    case ATTACHMENT_UPLOAD_DOCUMENTS_REQUEST:
      return { ...state, loading: true, error: null, uploadResults: null }
    case ATTACHMENT_UPLOAD_DOCUMENTS_SUCCESS:
      return { ...state, loading: false, uploadResults: action.payload }
    case ATTACHMENT_UPLOAD_DOCUMENTS_FAIL:
      return { ...state, loading: false, error: action.payload }

    // Generate SAS URLs
    case ATTACHMENT_GENERATE_SAS_URLS_REQUEST:
      return { ...state, loading: true, error: null, sasUrls: null }
    case ATTACHMENT_GENERATE_SAS_URLS_SUCCESS:
      return { ...state, loading: false, sasUrls: action.payload }
    case ATTACHMENT_GENERATE_SAS_URLS_FAIL:
      return { ...state, loading: false, error: action.payload }

    // Delete Internal Document
    case ATTACHMENT_DELETE_DOCUMENT_REQUEST:
      return { ...state, loading: true, error: null, deleteSuccess: false }
    case ATTACHMENT_DELETE_DOCUMENT_SUCCESS:
      return { ...state, loading: false, deleteSuccess: true }
    case ATTACHMENT_DELETE_DOCUMENT_FAIL:
      return { ...state, loading: false, error: action.payload, deleteSuccess: false }

    // Reset
    case ATTACHMENT_RESET:
      return initialState

    default:
      return state
  }
}
